'use client';

import { useState } from 'react';

import { ISeoSpeciesFamilyItem } from '@domain/species/types';
import { Button } from '../Clickables/Buttons/Button';
import { Pill } from '../Clickables/Pill/Pill';
import { Container } from '../Container/Container';
import { Heading } from '../Heading/Heading';
import { ChevronDownIcon } from '../Icons/ChevronDownIcon';
import { ChevronUpIcon } from '../Icons/ChevronUpIcon';

import { SEOFishFamily } from './components/SEOFishFamily';

interface IProps {
  seoSpeciesFamilies: ISeoSpeciesFamilyItem[];
  seoSpeciesDefaultFamily: ISeoSpeciesFamilyItem;
}

export const SEOFishFamilies = ({ seoSpeciesFamilies, seoSpeciesDefaultFamily }: IProps) => {
  const [selectedpecies, setSelectedSpecies] =
    useState<ISeoSpeciesFamilyItem>(seoSpeciesDefaultFamily);
  const [showMore, setShowMore] = useState<boolean>(false);
  const headingText = `Find fishing spots for ${selectedpecies.seoFamilyName} near you`;

  return (
    <Container className="-px-6 sm:-px-11 md:-px-14 mb-sm">
      <div className="p-6">
        <div className="border-twilight bg-sea-foam mx-auto max-w-[900px] rounded-lg border-2 p-4 sm:w-3/4 sm:p-8 md:p-10">
          <Heading variant="sm" as="h3" className="mb-6">
            {headingText}
          </Heading>

          <div className="flex">
            <div>
              {seoSpeciesFamilies.flatMap((family, index) => {
                if (family.seoFamilySpecies.length === 0) {
                  return [];
                }
                return (
                  <Pill
                    key={family.seoFamilyName}
                    variant="twilight"
                    className={`mr-2 mb-2 ${index > 4 && !showMore ? 'hidden' : ''} `}
                    size="sm"
                    isActive={selectedpecies.seoFamilyName === family.seoFamilyName}
                    onClick={() => {
                      setSelectedSpecies(family);
                    }}
                  >
                    {family.seoFamilyName}
                  </Pill>
                );
              })}
            </div>

            <div className="flex h-full items-end">
              {!showMore ? (
                <Button
                  variant="textPrimary"
                  className="sm:mt-1"
                  onClick={() => {
                    setShowMore(true);
                  }}
                >
                  <ChevronDownIcon size={24} />
                </Button>
              ) : (
                <Button
                  variant="textPrimary"
                  className="sm:mt-1"
                  onClick={() => {
                    setShowMore(false);
                  }}
                >
                  <ChevronUpIcon size={24} />
                </Button>
              )}
            </div>
          </div>

          {seoSpeciesFamilies.map(family => (
            <SEOFishFamily
              key={family.seoFamilyName}
              family={family}
              className={selectedpecies.seoFamilyName === family.seoFamilyName ? 'block' : 'hidden'}
            />
          ))}
        </div>
      </div>
    </Container>
  );
};
